// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2-hg1";
export var col1 = "footer-module--col1--AT64d";
export var col2 = "footer-module--col2--2N1LQ";
export var col3 = "footer-module--col3--7FWpw";